/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY2hlY2tsaXN0LXByb2ZpbGUtc3VydmVpcy9jaGVja2xpc3QtcHJvZmlsZS1zdXJ2ZXkvY2hlY2tsaXN0LXByb2ZpbGUtc3VydmV5LmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2NoZWNrbGlzdC1wcm9maWxlLXN1cnZlaXMvY2hlY2tsaXN0LXByb2ZpbGUtc3VydmV5L2NoZWNrbGlzdC1wcm9maWxlLXN1cnZleS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/checklist-profile-surveis/checklist-profile-survey/checklist-profile-survey.component.scss.shim.ngstyle.ts